import EnquireInfo from './EnquireInfo';

export default EnquireInfo;



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/components/EnquireModal/parts/EnquireInfo/index.js